import { useQuery } from "@tanstack/react-query";
import { Sparkle } from "@phosphor-icons/react";
import api from "../../lib/api";
import { Button } from "../ui/button";
import DemographicsWizard from "./DemographicsWizard";

export default function DemographicsBanner() {
  const { data: session, isLoading } = useQuery({
    queryKey: ["demographics-onboarding-status"],
    queryFn: () => api.get("/portal/onboarding").then((r) => r.data).catch(() => null),
    staleTime: 30000,
  });

  if (isLoading || !session || session.completed) return null;

  const data = session.data || {};
  const filled = ["dob", "address_line1", "filing_status", "occupation", "ssn"].filter((k) => data[k] && String(data[k]).trim());
  const pct = Math.round((filled.length / 5) * 100);

  return (
    <div className="rounded-lg border border-indigo-200 bg-gradient-to-br from-indigo-50 to-indigo-100/30 px-4 py-3 flex items-center gap-4" data-testid="demographics-banner">
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <p className="text-sm font-semibold text-indigo-900 flex items-center gap-1.5">
            <Sparkle size={13} weight="fill" /> Finish your client info
          </p>
          <span className="text-[10px] font-mono text-indigo-700 bg-white/80 rounded-sm border border-indigo-200 px-1.5 py-0.5" data-testid="demographics-banner-pct">
            {pct}% complete
          </span>
        </div>
        <p className="text-[11.5px] text-indigo-800/80 mt-0.5">
          A few minutes now saves your preparer hours later — demographics flow straight into your Drake return.
        </p>
      </div>
      <DemographicsWizard
        trigger={
          <Button size="sm" variant="secondary" className="bg-slate-900 text-white hover:bg-slate-800" data-testid="demographics-banner-open">
            {pct === 0 ? "Get started" : "Continue"}
          </Button>
        }
      />
    </div>
  );
}
